export class HubspotController {
    static $inject = ['HUBSPOT_FRAME_URL', '$sce'];
    constructor(HUBSPOT_FRAME_URL, $sce) {
        'ngInject';
        this.HUBSPOT_FRAME_URL = HUBSPOT_FRAME_URL;
        this.$sce = $sce;
        this.frameUrl = this.$sce.trustAsResourceUrl(HUBSPOT_FRAME_URL);
    }
}
HubspotController.$inject = ['HUBSPOT_FRAME_URL', '$sce'];
